import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AgrChartModule } from '@next/core-lib/chart';
import {
  AgrChipsFilterModule,
  AgrPageDetailModule,
  AgrPageToolbarModule,
  AgrSummaryCardModule,
} from '@next/core-lib/components';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';
import { AgrDatePipe } from '@next/core-lib/i18n';
import { AgrSettingsModule, SettingsService } from '@next/core-lib/settings';
import { AgrSharedModule } from '@next/core-lib/shared';

import { AgrTableModule } from '@next/core-lib/table';

import { AdditiveComponent } from './components/additive/additive.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';

import { SettingsServiceHelper } from './services/settingsHelperService';

@NgModule({
  declarations: [UnauthorizedComponent, AdditiveComponent],
  imports: [
    AgrFormModule,
    AgrChipsFilterModule,
    AgrChartModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTableModule,
    MatSelectModule,
    MatTooltipModule,
    AgrSharedModule,
    AgrPageToolbarModule,
    MatButtonModule,
    MatRadioModule,
    MatSlideToggleModule,
    AgrTableModule,
    AgrSettingsModule,
    CommonModule,
    AgrDialogModule,
    AgrPageDetailModule,
    AgrSummaryCardModule,
    MatListModule,
    MatAutocompleteModule,
  ],
  exports: [
    AgrSharedModule,
    AgrChipsFilterModule,
    AgrChartModule,
    MatChipsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTableModule,
    MatSelectModule,
    MatTooltipModule,
    UnauthorizedComponent,
    AdditiveComponent,
  ],
  providers: [SettingsService, AgrDatePipe, SettingsServiceHelper],
})
export class SharedModule {}
